import { DA_CATEGORIES } from '../../lib/daCategories';
import { PRICE_RANGE_DEFS } from '../../lib/constants';
import { shortCouncilName } from '../../config/registry';

import { ALL_COUNCILS, ALL_STATUS_KEYS } from './dashboardFilterOptions-v1';

export default function DashboardFilterChips({
  selectedCategories, councils, togC, stFilt, setStFilt, selectedTrade, allCat,
  trade, setSelectedTrade, safeRanges, togPriceRange, appTypeFilter, setAppTypeFilter, theme,
}) {
  const safeCats = Array.isArray(selectedCategories) ? selectedCategories : [];
  const chips = [];

  // Council chips — show selected councils when not all 4 active
  if (councils.length < ALL_COUNCILS.length) {
    councils.forEach(c => {
      const short = shortCouncilName(c);
      chips.push({ key: `c-${c}`, label: short, onRemove: () => togC(c) });
    });
  }

  // Status chips — show active statuses when not every status group is active
  if (stFilt.length < ALL_STATUS_KEYS.length) {
    stFilt.forEach(s => chips.push({ key: `s-${s}`, label: s, onRemove: () => setStFilt(s) }));
  }

  // Category chip — show count when any category is deselected
  if (!selectedTrade && safeCats.length < DA_CATEGORIES.length) {
    chips.push({ key: 'cat', label: `${safeCats.length}/${DA_CATEGORIES.length} project categories`, onRemove: () => allCat && allCat() });
  }

  if (trade) chips.push({ key: 'trade', label: trade.label, onRemove: () => setSelectedTrade('') });

  // Price range chips — one per selected bracket
  safeRanges.forEach(rangeId => {
    const range = PRICE_RANGE_DEFS.find(r => r.id === rangeId);
    if (range) chips.push({ key: `p-${rangeId}`, label: range.label, onRemove: () => togPriceRange && togPriceRange(rangeId) });
  });

  // App type chip
  if (appTypeFilter && appTypeFilter !== 'All') {
    chips.push({ key: 'apptype', label: `${appTypeFilter} only`, onRemove: () => setAppTypeFilter('All') });
  }

  if (chips.length === 0) return null;
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10 }}>
      {chips.map(chip => (
        <div key={chip.key} style={{
          display: "inline-flex", alignItems: "center", gap: 4,
          background: theme.bgCard, border: `1px solid ${theme.border}`,
          borderRadius: 20, padding: "4px 8px 4px 10px",
          fontSize: 12, color: theme.text,
        }}>
          <span>{chip.label}</span>
          <button type="button" aria-label={`Remove ${chip.label} filter`} onClick={chip.onRemove} style={{
            background: "none", border: "none", cursor: "pointer",
            color: theme.textMuted, fontSize: 15, lineHeight: 1,
            padding: "0 2px", display: "flex", alignItems: "center",
          }}>×</button>
        </div>
      ))}
    </div>
  );
}
